// Normalize any API response payload into an array.
//
// Accepts: a bare array, a DRF-paginated `{results: [...]}` envelope,
// `null`/`undefined`, or an unexpected object. Always returns an array
// so callers can do `.map(...)` / `.length` without a crash guard.
//
// Use this at every state setter that feeds a list-rendering component
// (`setRows(toArray(data))`). Prefer normalising at the setter over
// guarding at each render site — fewer places to forget.
export function toArray(x) {
  if (Array.isArray(x)) return x;
  if (x && Array.isArray(x.results)) return x.results;
  return [];
}
